
<!-- this include is not part of the sample - it's used to control the sample-->
<div class="container sample">
  <div class="row sample-controls-control">
    <div class="col">
      <div class="btn-group">
        <button class="btn btn-warning" type="button" (click)="showDemoControls = !showDemoControls">Toggle Demo Controls</button>
      </div>
    </div>
  </div>
  <div class="sample-controls card-item" [hidden]="!showDemoControls">
    <div class="row">
      <div class="col">
        <div class="float-right">
          <button class="btn btn-outline-danger" type="button" (click)="showDemoControls = false">Close</button>
        </div>
        <div class="float-left">
          <p>This card is not part of the sample.<br> Click the checkboxes to change options.</p>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-6"><b>Description</b>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="saveButton" autoLinkToLabel>
              <label class="form-check-label">Show save button</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="otherViewButton" autoLinkToLabel>
              <label class="form-check-label">Show other view (back) button</label>
            </div>
          </div>
          <div class="col-6"><b>Table</b>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="showTable" autoLinkToLabel>
              <label class="form-check-label">Show table</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="tableHasItems" autoLinkToLabel>
              <label class="form-check-label">Table has items</label>
            </div>
          </div>
          <div class="col-6"><b>Cards</b>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="showCards" autoLinkToLabel>
              <label class="form-check-label">Show cards</label>
            </div>
          </div>
          <div class="col-6"><b>Forms</b>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="showForm1" autoLinkToLabel>
              <label class="form-check-label">Show 2-column form</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="showForm2" autoLinkToLabel>
              <label class="form-check-label">Show 1-column form</label>
            </div>
          </div>
          <div class="col-6"><b>Shared</b>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="searchBox" autoLinkToLabel>
              <label class="form-check-label">Show search input</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="extraActionButton" autoLinkToLabel>
              <label class="form-check-label">Show extra action button</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="extraActionButtonIsDropdown" autoLinkToLabel>
              <label class="form-check-label">Extra action button is a dropdown</label>
            </div>
          </div>
        </div>
      </div>
      <div class="col scroller">
        <p><b>Notes:</b></p>
        <ul>
          <li>The indicated "Save" button can be used for other things, or even be a dropdown</li>
          <li>Split dropdowns are currently buggy and not recommended</li>
          <li>
            If the first item is a table or card list with an action button, try to avoid having a "Save" button in the description too (reduce clutter)</li>
          <li>
            Prefer actions (including dropdown) by the description rather than in a table or card list. Use the button in the table or card list if it is a separate component,
             or if it has many non-workflow-related controls.
          </li>
          <li>
            The code for this page forces this step to display, even for incorrect role. Your step should enforce properer UI security.</li>
          <li>
            The code for this page uses a lot of *ngIf directives to control what's visible. Your step should not need these, as parts will generally always be visible.</li>
          <li>In the future, there will be new workflow control options:
            <ul>
              <li>Save when moving to the next step (user will be prompted) - based on a future flag and dirty check</li>
              <li>Mark current step as complete when moving to the next step - based on a future flag</li>
            </ul>For this reason, it is important to remember to toggle dirty on your workflow step's component
             when data is changed but not saved (and toggle back when saved), otherwise there will be a large
             amount of cleanup work necessary.
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- commented out workflow-no-access and added false&& to help with demo - you need these in yours though-->
<!--workflow-no-access([workflowTargetInfo]='workflowTargetInfo')-->
<div class="container" [hidden]="false&amp;&amp;!workflowTargetInfo.correctRole">
  <!-- description-->
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left pr-3">
        <div class="btn-group">
          <button class="btn btn-outline-secondary" type="button" *ngIf="otherViewButton">View Devices</button>
        </div>
      </div>
      <div class="float-left">
        <p>This is the step description. It is contained in a &lt;p&gt;. The first line is designed to line up with buttons.</p>
      </div>
      <div class="float-right">
        <div class="btn-group">
          <button class="btn btn-primary" type="button" *ngIf="saveButton">Save</button>
        </div>
      </div>
    </div>
  </div>
  <!-- table-->
  <div class="row" *ngIf="showTable">
    <div class="col">
      <div class="table-card">
        <list-controls [showSearch]="searchBox" [showLimit]="true" [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)">
          <div class="btn-group float-right" *ngIf="extraActionButton &amp;&amp; !extraActionButtonIsDropdown">
            <button class="btn btn-primary" type="button">Do Stuff</button>
          </div>
          <div class="btn-group dropdown float-right" *ngIf="extraActionButton &amp;&amp; extraActionButtonIsDropdown">
            <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Do Stuff</button>
            <div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" href="javascript:void(0);">Do Other Stuff</a><a class="dropdown-item" href="#/projects">Leave This Page</a><a class="dropdown-item" [routerLink]="['/projects']">Also Leave This Page</a></div>
          </div>
        </list-controls>
        <table class="table table-responsive">
          <thead>
            <tr class="table-header-with-controls">
              <th>Header 1</th>
              <th>Header 2</th>
              <th>Header 3</th>
              <th>Header 4</th>
              <th>Header 5</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="tableHasItems">
              <td>R1C1</td>
              <td>R1C2</td>
              <td>R1C3</td>
              <td>R1C4</td>
              <td>R1C5</td>
            </tr>
            <tr *ngIf="tableHasItems">
              <td>R2C1</td>
              <td>R2C2</td>
              <td>R2C3</td>
              <td>R2C4</td>
              <td>R2C5</td>
            </tr>
            <tr *ngIf="!tableHasItems">
              <td colspan="5">
                <p class="text-center empty-table-message">There are no devices to display.</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!-- cards-->
  <div class="row" *ngIf="showCards">
    <div class="col">
      <list-controls [showSearch]="searchBox" [showLimit]="true" [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)">
        <div class="btn-group float-right" *ngIf="extraActionButton &amp;&amp; !extraActionButtonIsDropdown">
          <button class="btn btn-primary" type="button">Do Stuff</button>
        </div>
        <div class="btn-group dropdown float-right" *ngIf="extraActionButton &amp;&amp; extraActionButtonIsDropdown">
          <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Do Stuff</button>
          <div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" href="javascript:void(0);">Do Other Stuff</a><a class="dropdown-item" href="#/projects">Leave This Page</a><a class="dropdown-item" [routerLink]="['/projects']">Also Leave This Page</a></div>
        </div>
      </list-controls>
    </div>
  </div>
  <div class="row" *ngIf="showCards">
    <div class="col">
      <!-- repeat this next .row for each card-->
      <div class="row">
        <div class="col">
          <div class="card-item">
            <h4>Some Card</h4>
            <property-container>
              <property-item>Card Contents</property-item>
            </property-container>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="card-item">
            <h4>Some Card</h4>
            <property-container>
              <property-item>Card Contents</property-item>
            </property-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- wide form-->
  <form *ngIf="showForm1">
    <div class="row">
      <div class="col">
        <div class="card-block">
          <div class="row">
            <div class="col">
              <h4>Section 1</h4>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" for="name1">Name 1:</label>
              <input class="form-control" id="name1" type="text" name="name1" maxlength="128" required>
            </div>
            <div class="form-group col md-6">
              <label for="name2">Name 2:</label>
              <input class="form-control" id="name2" type="text" name="name2" maxlength="128">
            </div>
          </div>
          <div class="row">
            <div class="col">
              <h4>Section 2</h4>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" for="line1">Line 1:</label>
              <input class="form-control" id="line1" type="text" name="line1" maxlength="128" required>
            </div>
            <div class="form-group col-lg-6">
              <label for="line2">Line 2:</label>
              <input class="form-control" id="line2" type="text" name="line2" maxlength="128">
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <!-- narrow form-->
  <form *ngIf="showForm2">
    <div class="row justify-content-md-center">
      <div class="col-md-8">
        <div class="card-block">
          <div class="row">
            <div class="col">
              <h4>Section 1</h4>
            </div>
          </div>
          <div class="row">
            <div class="form-group col">
              <label class="required" for="name1a">Name 1:</label>
              <input class="form-control" id="name1a" type="text" name="name1a" maxlength="128" required>
            </div>
          </div>
          <div class="row">
            <div class="form-group col">
              <label for="name2a">Name 2:</label>
              <input class="form-control" id="name2a" type="text" name="name2a" maxlength="128">
            </div>
          </div>
          <div class="row">
            <div class="col">
              <h4>Section 2</h4>
            </div>
          </div>
          <div class="row">
            <div class="form-group col">
              <label class="required" for="line1a">Line 1:</label>
              <input class="form-control" id="line1a" type="text" name="line1a" maxlength="128" required>
            </div>
          </div>
          <div class="row">
            <div class="form-group col">
              <label for="line2a">Line 2:</label>
              <input class="form-control" id="line2a" type="text" name="line2a" maxlength="128">
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>